import React from "react";
import { MainScreen } from "../main-screen/main-screen";
import { InfoUnit } from "../info-unit/info-unit";
import { InfoUnitMobiles } from "../info-unit/info-unit-mobiles";
import "../../constructor/common.css";
import { FeatureBlock } from "../feature-block/feature-block";
import { AboutBlock } from "../about-block/about-block";
import { Footer } from "../../footer/footer";
import { FeatureCard } from "../feature-block/feature-card";
// import { Reviews } from "../../reviews/reviews";

export const CaseSharxDesignSystem = () => {
	document.title =
		"Дизайн-система для Sharx DC - ускорение разработки и единый стиль продуктов";
	document.getElementsByTagName("META")[2].content =
		"Дизайн-система для Sharx DataCenter: единый стиль и стандарты для продуктов, удобство использования, улучшение UX и упрощение разработки";

	document.getElementsByTagName("META")[3].content =
		"UX/UI дизайн, разработка дизайна для блокчейн-платформ, создание продуктовых страниц, дизайн интерфейсов. дизайн цифровых продуктов, UX/UI для криптовалютных платформ, UX/UI дизайн студия, дизайн для цифрового бизнеса, проектирование пользовательских интерфейсов, разработка дизайна для цифровых продуктов, профессиональный дизайн для стартапов";

	return (
		<>
			<MainScreen
				backgroundColor="#ECF5FE"
				titleColor="#1152F8"
				textColor="#242323"
				isHeaderOnDark
			/>

			<AboutBlock />

			<FeatureBlock
				backgroundColor="#1152F8"
				textColor="#ffffff"
				paddingBottom={true}
			>
				<InfoUnit
					title="Типографика и цвета"
					text={[
						"Мы разработали систему типографики и цветовую палитру как важную часть дизайн-системы. Эти элементы создают основу для визуальной идентичности компании и обеспечивают её единообразие во всех цифровых продуктах и коммуникациях. Шрифты были выбраны так, чтобы сочетать заметность заголовков с удобным чтением основного текста. Цветовая палитра основана на сочетании нейтральных оттенков с акцентами глубокого синего — символа надежности, технологий и инноваций. ",
					]}
					textColor="#ffffff"
					picture="/img/sharxdesignsystem/sharx-dc-wjet-typography-3.png"
					pictureAlt="Сетка, отступы и переменные в дизайн-системе Sharx DC"
				/>
			</FeatureBlock>

			<FeatureBlock backgroundColor="#ECF5FE" textColor="#242323">
				<InfoUnit
					title="Сетка, отступы и переменные"
					text={[
						"Система отступов, сетка и переменные — это фундаментальные инструменты нашей дизайн-системы, которые обеспечивают чёткую структуру и гибкость при создании интерфейсов для продуктов компании. Сетка и чёткая система отступов делает интерфейсы структурированными улучшает читаемость контента. ",
						"Переменные стандартизируют ключевые параметры, такие как размеры, интервалы и пропорции, что ускоряет процесс разработки и упрощает масштабирование продуктов. Благодаря переменным можно моментально увидеть, как изменения, например, цвета элемента, отражаются на всём проекте. Это также позволяет проводить мягкий редизайн, адаптируясь к новым трендам, без необходимости заново настраивать или проверять интерфейсы.",
					]}
					textColor="#242323"
					picture="/img/sharxdesignsystem/sharx-dc-wjet-variables-4-2.png"
					picture2="/img/sharxdesignsystem/sharx-dc-wjet-variables-4-1.png"
					pictureAlt="Библиотека UI-элементов в дизайн-системе"
				/>
			</FeatureBlock>

			<FeatureBlock backgroundColor="#ffffff" title="" textColor="#242323">
				<InfoUnit
					textColor="Кнопки и поля ввода"
					title="Кнопки и поля ввода"
					text={[
						"Кнопки и поля ввода — это важнейшие элементы интерфейса, поэтому мы разработали для них универсальную и гибкую систему. Главная цель была создать единый стиль и восприятие во всех интерфейсах. Мы учли разнообразные сценарии использования и особенности продуктов, чтобы обеспечить их стабильную работу в любых условиях.",
					]}
					picture="/img/sharxdesignsystem/sharx-dc-wjet-ui-5.png"
				/>
			</FeatureBlock>

			<FeatureBlock backgroundColor="#1152F8" textColor="#ffffff">
				<InfoUnit
					title="UI элементы"
					text={[
						"Дополнительные UI-элементы обеспечивают единый стиль интерфейса и ускоряют разработку за счет готовых шаблонов. Мы детально проработали их адаптивность и совместимость, чтобы элементы корректно работали на любых устройствах и разрешениях. В итоге дизайн-система стала универсальным инструментом для создания понятных и функциональных продуктов.",
					]}
					textColor="#ffffff"
					picture="/img/sharxdesignsystem/sharx-dc-wjet-components-6.png"
				/>
			</FeatureBlock>

			<FeatureBlock
				backgroundColor="#ECF5FE"
				textColor="#242323"
				borderRadius={48}
			>
				<InfoUnit
					title="Конструктор таблиц"
					text={[
						"При создании дизайн-системы мы разработали гибкий конструктор таблиц, который позволяет настраивать отображение данных под различные сценарии использования. Конструктор помогает быстро адаптировать таблицы под различные задачи: добавлять или удалять столбцы, настраивать типы данных и действия.",
						"В этом проекте таблицы используются активно, особенно на ключевых экранах. Мы разработали более 40 уникальных типов ячеек, что позволило быстро собирать таблицы, тестировать их и находить оптимальный баланс между объемом данных и их понятностью. Это помогает быстрее находить удачные решения для отображения информации. Благодаря конструктору интерфейсы остаются функциональными и простыми в использовании, при этом разработка и масштабирование системы стали значительно быстрее.",
					]}
					textColor="#242323"
					picture="/img/sharxdesignsystem/sharx-dc-wjet-tables-7.png"
					pictureAlt="Конструктор таблиц в дизайн-системе"
				/>
			</FeatureBlock>

			<FeatureBlock title="" backgroundColor="#1152F8" textColor="#242323">
				<InfoUnit
					title="Минимум компонентов, максимум гибкости"
					text={[
						"Мы создали продуманную дизайн-систему, которая стала фундаментом для всех продуктов Sharx DataCenter. Она ускоряет и упрощает процесс разработки: несколько версий страницы можно собрать менее чем за час, а сложные сценарии проработать за 2–3 часа вместо нескольких дней. Это решение оптимизирует реализацию проектов, снижает затраты и позволяет компании сосредоточиться на стратегически важных задачах. Дизайн-система обеспечивает удобство для пользователей и создает прочную базу для масштабирования и роста продуктов.",
					]}
					textColor="#ffffff"
				/>
			</FeatureBlock>

			{/* <FeatureBlock 
			backgroundColor="#303030" 
									textColor="#242323"

			title="Отзыв заказчика">
				<InfoUnit
										textColor="#242323"

					text={[
						" Получилось именно то, что мы хотели — лаунчпад понятный, без лишнего, всё как надо. Отдельный респект за скорость — для нас сроки были критически важны, особенно сейчас, когда рынок горячий. Благодаря вашей оперативности мы уже получили инвестиции и активно привлекаем	проекты. Еще раз спасибо за профессионализм — работать с вами одно удовольствие! Савельев Алексей (CEO BoostPad)",
						]}
					// picture="/img/boostpad/wjet-review.png"

				/>
			</FeatureBlock> */}

			{/* <Reviews /> */}

			<section className="design" id="design">
				<div className="container" id="contacts">
					<Footer backgroundColor="transparent" />
				</div>
			</section>
		</>
	);
};
